<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center w-100"
    style="height: 100vh"
  >
    <h1>404 Not Found</h1>
    <p>Oops! The page you are looking for does not exist.</p>
    <a class="cursor-pointer" @click="goBack">Go back</a>
  </div>
</template>

<script>
export default {
  name: "NotFoundView",
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style></style>
